<template>
	<div class="site-not-available-wrapper">
		<div class="site-not-available-header"><img :src="`${staticPath}images/foodshop-logo.png`" class="image-position"/></div>
		<div class="site-not-available-body">
			<div class="site-not-available-text-wrapper">
				<div class="site-not-available-text-title">
					{{$t("shopComponents.gtDemo.tenants.siteNotAvailableTid100.siteNotAvailable")}}
				</div>
				<div class="site-not-available-text-sub">
					{{tenantSettings.tenantUnavailableCustomText ? tenantSettings.tenantUnavailableCustomText : $t("shopComponents.gtDemo.tenants.siteNotAvailableTid100.customText")}}
				</div>
			</div>
			<div class="site-not-available-footer">
				<v-btn flat @click="siteNotAvailableRedirect">{{$t("shopComponents.gtDemo.tenants.siteNotAvailableTid100.redirection")}}</v-btn>
			</div>
		</div>
	</div>
</template>

<script>
	import * as Utils from "../../../../libraries/utils";
	import {mapGetters} from "vuex";
	export default {
		name: "SiteNotAvailableTid1",
		props: ["siteNotAvailableRedirect"],
		computed: {
			...mapGetters(["tenantSettings"]),
			staticPath() {
				return Utils.getStaticPath();
			}
		}
	};
</script>

<style scoped lang="scss">
	.site-not-available-wrapper {
		background-color: #ffffff;
		position: relative;
		max-width: 500px;
		margin: auto;
		.site-not-available-header {
			height: 58px;
			width: 100%;
			background-color: black;
			position: relative;
			img {
				height: 44px;
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
			}
		}
		.site-not-available-body {
			height: calc(100vh - 58px);;
			align-items: flex-end;
			padding: 0;
			background-size: 100% 100%;
			background-position: center;
			.site-not-available-text-wrapper {
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
				width: 100%;
				color: #231f20;
				.site-not-available-text-title {
					font-size: 22px;
					text-align: center;
					font-weight: bold;
					max-width: 12em;
					margin: auto;
					line-height: normal;
					text-transform: uppercase;
				}

				.site-not-available-text-sub {
					font-size: 16px;
					text-align: center;
					padding-top: 1.5em;
					max-width: 20.7em;
					margin: auto;
				}
			}
			.site-not-available-footer {
				position: fixed;
				bottom: 0;
				height: 66px;
				background-color: #ffc627;
				width: 100%;
				max-width: 500px;
				text-align: center;
				padding: 0 16px 16px 16px;
				z-index: 10000;
				.v-btn {
					width: 100%;
					height: 100%;
					margin: 0;
					padding: 0;
					background-color: #000000;
					border-radius: 4px;
					border: 1px solid #000000;
					/deep/ .v-btn__content {
						font-size: 22px;
						color: #ffffff;
						letter-spacing: 1px;
					}
				}
			}
		}
	}
</style>
